import { render, staticRenderFns } from "./ConferenceChat.vue?vue&type=template&id=84a11ad6&"
import script from "./ConferenceChat.vue?vue&type=script&lang=js&"
export * from "./ConferenceChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports